import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

/* StrictMode bilerek kapalı: efektleri iki kez çalıştırdığı için
   GSAP context ilk ScrollTrigger'ı geri alıyor ve ikincisi ilk
   yenilemeyi hiç almıyordu. Pin mesafesi bu yüzden sıfır kalıyordu. */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
